import { storyblokEditable } from "@storyblok/react/rsc";

import { DotListItem } from "@/components/layout/DotListItem";

type DisclaimerListItemStoryblok = {
  text: string;
  _uid: string;
  component: "disclaimer_list_item";
  [k: string]: any;
};

type DisclaimerListItemProps = {
  blok: DisclaimerListItemStoryblok;
};

const DisclaimerListItem = ({ blok }: DisclaimerListItemProps) => {
  return (
    <div {...storyblokEditable(blok)}>
      <DotListItem className="[&>span]:text-black-80">{blok.text}</DotListItem>
    </div>
  );
};

export default DisclaimerListItem;
